export enum PendingReason {
  MISSING_APPROVALS = 'MissingApprovals',
  MISSING_BOOKING = 'MissingBooking',
  MISSING_BOOKABLE_RESOURCE = 'MissingBookableResource',
  MISSING_BOOKING_DATE = 'MissingBookingDate',
}
